import React, { useContext } from "react";
import { Layer, Source } from "react-map-gl";
import { AppContext } from "../../../contexts/AppContext";
import { vectorSource } from "./helpers.layers";

/**
 * Renders a base geographic layer for regional maps using react-map-gl
 * @param {Object} props - Component props
 * @param {string} props.layerId - Unique identifier for the map layer
 * @param {boolean} props.renderLayer - Controls layer visibility
 * @param {string} props.hoverInfo - Region ID for highlighting hovered regions
 * @param {Function} props.getBeforeIdLayerId - Function that returns the ID of the layer this should be rendered before
 * @returns {React.Component} A Source and Layer combination for displaying regional boundaries
 */
export default function GidBaseLayer({ layer, getBeforeIdLayerId, hoverInfo }) {
  const { mapboxId, sourceId, layerId, sourceLayer, renderLayer, opacity } = layer;

  const { pathLocation } = useContext(AppContext);
  const _sourceId = pathLocation.includes("ecowas")
    ? "ecowas_region"
    : pathLocation.includes("sadc")
    ? "sadc_region"
    : pathLocation.includes("east")
    ? "east_region"
    : pathLocation.includes("africa")
    ? "ecowas_region"
    : "ecowas_region";

  return (
    // <Source {...vectorSource(mapboxId, sourceId)}>
    <Source {...vectorSource(_sourceId, _sourceId)}>
      <Layer
        id={`${layerId}-region`}
        source-layer="region"
        // source-layer={sourceLayer}
        beforeId={getBeforeIdLayerId()}
        type="fill"
        layout={{
          visibility: renderLayer ? "visible" : "none",
        }}
        paint={{
          "fill-color": "transparent",
        }}
      />

      {hoverInfo && (
        <Layer
          id={`${layerId}-highlighted`}
          source-layer={"region"}
          //   source-layer={sourceLayer}
          // beforeId={getBeforeIdLayerId()}
          type="line"
          layout={{
            visibility: renderLayer ? "visible" : "none",
          }}
          filter={["==", ["get", "region_id"], hoverInfo]}
          paint={{
            // "line-color": "#ffffff",
            "line-color": "yellow",
            "line-width": 3,
          }}
        />
      )}
    </Source>
  );
}
